// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.a-icon[data-v-344c59cf] {\r\n  position: absolute;\r\n  z-index: 10;\r\n  right: 6px;\r\n  top: 13px;\r\n  pointer-events: none;\n}\ninput[data-v-344c59cf] {\r\n  cursor: pointer\n}\r\n", ""]);
// Exports
module.exports = exports;
